import styled from 'styled-components'

import {
  HEADER_HEIGHT,
  HEADER_MENU_BREAK_POINT,
  TOP_NAV_HEIGHT,
  BREAK_POINT_LG,
  SEARCH_PAGE_BOTTOM_FLOATING_BAR_HEIGHT,
} from '@CSSVars/variables'

export const _DockSideContainer = styled.div`
  width: 100%;
  display: ${({ dockIsOpen }) => ((dockIsOpen === null || dockIsOpen) ? 'block' : 'none')};
  flex: ${({ dockIsOpen }) => (dockIsOpen === null ? 1 : 'auto')};
  @media screen and (min-width: ${BREAK_POINT_LG}) {
    flex: 1;
  }
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    width: 100%;
    display: block;
    flex: auto;
  }
`

export const _ChildContainer = styled.div`

  ${({ isMobileApp, withEditBar }) => (isMobileApp ?
    'height: 100vh;'
    :
    `height: calc(100vh - ${HEADER_HEIGHT} ${withEditBar ? ' - 60px' : ''});`)}
  overflow: hidden;

  /*Remove Listings/Mobile Nav height from total height*/
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    height: calc(${({ winHeight }) => (winHeight ? `${winHeight}px` : '100vh')}
    ${({ isMobileApp }) => (isMobileApp ? '' : ` - ${HEADER_HEIGHT}`)}
    - ${SEARCH_PAGE_BOTTOM_FLOATING_BAR_HEIGHT + ' + 10px'}) !important;
  }

  @media (orientation: landscape ) and (min-width: ${BREAK_POINT_LG})  {
    height: calc(100vh - ${HEADER_HEIGHT} + ${({ isIpad }) => (isIpad ? '34px' : '0')} - ${({ fullHeight }) =>
  (fullHeight ? 0 : SEARCH_PAGE_BOTTOM_FLOATING_BAR_HEIGHT)}) !important;
  }

  @media screen and (min-width: ${HEADER_MENU_BREAK_POINT}) {
    height: calc(100vh ${({ isMobileApp, withEditBar }) => (isMobileApp ? ''
    : ` - (${TOP_NAV_HEIGHT} + ${HEADER_HEIGHT} + ${withEditBar ? '100px' : '0px'})`)});
  }
`
